import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-input-date-filter',
  templateUrl: './input-date-filter.component.html',
  styleUrls: ['./input-date-filter.component.scss']
})
export class InputDateFilterComponent implements OnChanges, OnInit {

  @Input() block: any;
  @Input() resetValue: any;
  @Input() firstInput: any;
  @Input() lastInput: any;
  @Output() onTyped = new EventEmitter();
  public value :any = null;
  public dateMax: string = "";

  constructor(public helpersService: HelpersService) {
  }

  ngOnInit(): void {
    if(this.block.value_sel && this.block.value_sel.from){
      this.value = formatDate(this.block.value_sel.from, 'dd-MM-yyyy', 'it-IT').toString();
    } else if(this.block.value_sel && this.block.value_sel.to){
      this.value = this.value = formatDate(this.block.value_sel.to, 'dd-MM-yyyy', 'it-IT').toString();
    }
    let date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();
    this.dateMax = [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
          ].join('-');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetValue'].currentValue) {
      this.value = null;
    }
  }

  changeVal(event: any): void {
    const ret: any = {};
    ret[this.block.filter_name] = event;
    this.onTyped.emit(ret);
  }

}
